'use strict';

import { decodeHtml } from '../../../../../_imports/shared/vue-utils.common';
import { prepareVideos } from '../../../../../../api/media/video';
import { apiUpdateLead } from '../../../../../../api/marketo';

const resourceCardCommon = {
    mixins: [decodeHtml],
    props: {
        linkType: String,
        resource: Object,
        styling: Object,
        popUpBehaviourActivated: Boolean,
        overrideCardWidth: [String, null]
    },
    computed: {
        overrideCardWidthStyles() {
            return this.overrideCardWidth ? `--override-card-width: ${this.overrideCardWidth}` : '';
        },
        resourceUrl: function() {
            const urlDto = {};

            switch (this.linkType) {
                case 'open-resource':
                    if (this.hasResourceLink()) {
                        urlDto.url = this.resource.registrationLink || this.resource.resourceLink;
                        urlDto.target = '_blank';
                    }
                    break;
                case 'external':
                   if (this.resource.externalUrl) {
                        urlDto.url = this.resource.externalUrl || this.resource.registrationLink;
                        urlDto.target = '_blank';
                        break;
                   }
                case 'landing':
                default:
                    urlDto.url = this.resource.registrationLink || this.resource.landingUrl;

                    if (urlDto.url.includes('/data/')) {
                        urlDto.url = this.resource.resourceLink;
                    }
                    
                    urlDto.target = '_self';
            }

            return urlDto;
        },
        hasThumbnail: function() { 
            return this.styling.displayThumbnails && ((this.resource.thumbnail && this.resource.thumbnail.src) || this.resource.thumbnailSrc);
        },
        thumbnailSrc() {
            return this.resource.thumbnailSrc || this.resource.thumbnail?.src;
        }
    },
    methods: {
        getResourceUrlTarget() {
            return;
        },
        hasResourceLink() {
            return this.resource.resourceLink && this.resource.resourceLink.split('=').filter(s => s).length > 1;
        },
        isVideo() {
            return this.resource.videoId;
        },
        shouldHoverWholeCard() {
            return this.linkType === 'open-resource';
        },
        resourceClick() {
            this.$el.classList.remove('highlight');
            
            if (this.resource.isComingSoon
                || this.linkType !== 'open-resource') {
                return;
            }

            let mktoAssetDownloadURL = '';

            if (this.isVideo()) {
                mktoAssetDownloadURL = `/watch?v%3D${this.resource.videoId}`;

                const imagePlaceholder = this.$el.querySelector('.resources-card-bg img');
                let externalLinks = '';

                if (this.resource.externalLinks) {
                    if (this.resource.externalLinks.spotify) {
                        externalLinks += `<a href="${this.resource.externalLinks.spotify}" class="spotify" target="_blank"><img src="/public/img/spotify.svg">Spotify</a>`;
                    }
    
                    if (this.resource.externalLinks.apple) {
                        externalLinks += `<a href="${this.resource.externalLinks.apple}" class="apple-music" target="_blank"><img src="/public/img/apple-podcasts.svg">Apple</a>`;
                    }
    
                    if (this.resource.externalLinks.google) {
                        externalLinks += `<a href="${this.resource.externalLinks.google}" class="google-play-music" target="_blank"><img src="/public/img/google-podcasts.svg">Google</a>`;
                    }
                }

                let externalLinksElement = '';

                if (externalLinks !== '') {
                    let externalLinksText = 'Listen on:';

                    if (lang === 'fr') {
                        externalLinksText = 'Écoutez sur :'
                    }
                    
                    externalLinksElement = `
                        <div class='video-modal-external-links-container'>
                            ${externalLinks ? `${externalLinksText} <div class='video-modal-external-links'>${externalLinks}</div>` : ''}
                        </div>
                    `;
                }

                const vidyardLightbox = `
                    <div class="vidyard-lightbox">
                        <div class="vidyard-lightbox-content">
                            <div class='video-modal-heading'>
                                <div class='video-modal-data-title'>${this.resource.title}</div>
                            </div>
                            <div class='video_placeholder vidyard-player-embed' data-provider='vidyard' data-code='${this.resource.videoId}' data-uuid='${this.resource.videoId}' data-parameters='' am-video-player data-video-player>
                                <div am-video-player-front>
                                    <img src='${imagePlaceholder.src}'>
                                    <div am-video-player-overlay></div>
                                    <div am-video-player-overlay-play-button='vidyard'>
                                        <div am-video-player-overlay-play-button-container></div>
                                        <svg fill="currentColor" aria-label="Play Video" focusable="false" role="img" version="1.1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" class="vidyard-play-icon"><path d="m6.484 4.094l20.75 11.225c0.226 0.121 0.41 0.427 0.41 0.683s-0.184 0.563-0.41 0.683l-20.75 11.222c-0.095 0.051-0.26 0.093-0.367 0.093-0.427 0-0.774-0.346-0.774-0.773v-22.451c0-0.428 0.347-0.774 0.774-0.774 0.108 0 0.272 0.042 0.367 0.093z"/></svg>
                                        <div am-loader='rolling'></div>
                                    </div>
                                </div>
                            </div>
                            ${externalLinksElement}
                        </div>
                    </div>
                `;

                lity(vidyardLightbox);

                prepareVideos();

                document.querySelector('.lity .video_placeholder').click();
                } else {
                    mktoAssetDownloadURL = this.resource.resourceLink.replace('file=', 'file%3D');
                }

                const updateLead = {
                    MarketoDetailIDUrl: window.location.href,
                    mktoAssetDownloadURL: `${window.location.protocol}//${window.location.hostname}${mktoAssetDownloadURL}`,
                };

                apiUpdateLead({
                    formSerializeString: updateLead
                });
            }
    }
};

export default resourceCardCommon;